export const showSnackbar = () => {
  return (dispatch) => {
    dispatch({
      type: 'show',
    });
  };
};

export const hideSnackbar = () => {
  return (dispatch) => {
    dispatch({
      type: 'hide',
    });
  };
};

export const setResponse = (response) => {
  return (dispatch) => {
    dispatch({
      type: 'setResponse',
      payload: response,
    });
  };
};

export const setArea = (response) => {
  return (dispatch) => {
    dispatch({
      type: 'setArea',
      payload: response,
    });
  };
};

export const appendCleaningAreas = (item) => {
  return (dispatch) => {
    dispatch({
      type: 'appendCleaningAreas',
      payload: item,
    });
  };
};

export const appendOptions = (item) => {
  return (dispatch) => {
    dispatch({
      type: 'setOptions',
      payload: item,
    });
  };
};

export const setActiveTab = (activeTab) => {
  return (dispatch) => {
    dispatch({
      type: 'setActiveTab',
      payload: activeTab,
    });
  };
};

export const setActiveBtn = (activeBtn) => {
  return (dispatch) => {
    dispatch({
      type: 'setActiveBtn',
      payload: activeBtn,
    });
  };
};

export const setCleanTs = (ts) => {
  return (dispatch) => {
    dispatch({
      type: 'setCleanTs',
      payload: ts,
    });
  };
};
